export default __webpack_public_path__ + "static/media/reward1_detail_7-2.974cf623.png";